<template>
    <div class="container">
        <h2 class="title is-5">おみくじアプリ</h2>
        <p>おみくじアプリのサンプルコードです。</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <OmikujiComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p class="subtitle is-6" style="font-weight:bold;">参考になったら、ブログやQiita、Crieit等でこのサイトのリンクを参考記事として載せていただると喜びます！</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/68fe60bb7240c019454654b689faf743" data-iframely-url="//cdn.iframe.ly/RRsjOW9"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>Math.ramdomで乱数を作ります。</p>
        <p>choiceの配列に入れた運勢をresultに代入します。</p>
    </div>
</template>

<script>
import OmikujiComponent from  '@/components/OmikujiComponent.vue'
export default {
    components:{
        OmikujiComponent
    },
    mounted(){
        const title = "おみくじアプリのサンプル｜あめねこサンプルコード集"
        const description = "Vue.jsで作るおみくじアプリのサンプルコードです。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "おみくじアプリのサンプル" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/omikuji";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
}

</style>